module.exports = __webpack_public_path__ + "img/logo.5cdbc7fb.svg";